import { Smartphone, Download, ExternalLink, Apple } from "lucide-react";

export default function MobileAppCard() {
  const installUrl = window.location.origin;
  return (
    <section data-testid="mobile-app-card" className="border hairline bg-cream-card rounded-2xl p-6 md:p-8 mt-8">
      <div className="grid md:grid-cols-12 gap-6 items-center">
        <div className="md:col-span-7">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral mb-2 inline-flex items-center gap-1.5">
            <Smartphone className="w-3 h-3" /> App móvil
          </p>
          <h2 className="font-serif text-2xl md:text-3xl tracking-tight mb-2">
            Lleva Ovamx a tu bolsillo.
          </h2>
          <p className="text-sm text-ink-mid leading-relaxed mb-4">
            Instala Ovamx como aplicación nativa en tu Android o iPhone — sin necesidad de Play Store ni App Store.
            Funciona offline, recibes notificaciones push y se ve como cualquier app instalada.
          </p>
          <ol className="text-sm space-y-2 list-decimal list-inside text-ink/80">
            <li><strong>Android · Chrome</strong>: Abre el menú (⋮) → <em>Añadir a pantalla de inicio</em> → Instalar.</li>
            <li><strong>iPhone · Safari</strong>: Toca el botón compartir (▢↑) → <em>Añadir a pantalla de inicio</em>.</li>
            <li>El icono Ovamx aparecerá entre tus apps. Listo.</li>
          </ol>
          <div className="mt-5 flex flex-wrap gap-2">
            <a href={installUrl} data-testid="mobile-install-link"
               className="inline-flex items-center gap-1.5 text-xs px-4 py-2 rounded-full bg-coral text-white hover:bg-coral-hover transition">
              <Download className="w-3.5 h-3.5" /> Abrir Ovamx en el móvil
            </a>
            <a href="/MOBILE_APPS.md" target="_blank" rel="noreferrer"
               className="inline-flex items-center gap-1.5 text-xs px-4 py-2 rounded-full border hairline hover:border-coral transition">
              <ExternalLink className="w-3.5 h-3.5" /> Guía completa
            </a>
          </div>
        </div>

        <div className="md:col-span-5">
          <div className="rounded-2xl overflow-hidden border hairline bg-gradient-to-br from-coral/10 to-cream-deep aspect-square flex items-center justify-center relative">
            <div className="text-center">
              <div className="w-20 h-20 rounded-2xl bg-coral text-white inline-flex items-center justify-center font-serif text-4xl mb-3 shadow-lg">O</div>
              <p className="font-serif text-2xl">Ovamx</p>
              <p className="font-mono text-[10px] uppercase tracking-wider text-ink-mid mt-1">Tu tiempo tiene valor</p>
            </div>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            <div className="rounded-xl border hairline p-2.5 text-center">
              <Smartphone className="w-4 h-4 mx-auto text-coral mb-1" />
              <p className="text-[10px] font-mono uppercase tracking-wider">Android</p>
              <p className="text-[10px] text-ink-mid">PWA · Chrome</p>
            </div>
            <div className="rounded-xl border hairline p-2.5 text-center">
              <Apple className="w-4 h-4 mx-auto text-coral mb-1" />
              <p className="text-[10px] font-mono uppercase tracking-wider">iOS</p>
              <p className="text-[10px] text-ink-mid">PWA · Safari</p>
            </div>
          </div>
          <p className="mt-2 text-[10px] text-ink-mid font-mono text-center">
            APK firmada para Play Store: pronto · build con Capacitor
          </p>
        </div>
      </div>
    </section>
  );
}
